import { create } from "zustand";
import { persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import {
  createPageAnnotationSlice,
  PageAnnotationSlice,
} from "~/features/pageAnnotations/store/pageAnnotation.slice";
import {
  createSearchHighlightSlice,
  SearchHighlightSlice,
} from "./searchHighlight.slice";
import { createSidebarSlice, SidebarSlice } from "./sideBar.slice";

export type SkyViewStore = SidebarSlice &
  SearchHighlightSlice &
  PageAnnotationSlice;

type SkyViewPersistedState = {
  isExpanded: boolean;
  isDocListCollapsed: boolean;
  referenceHighlightsEnabled: boolean;
};

export const useSkyViewStore = create<SkyViewStore>()(
  persist(
    immer((...a) => ({
      ...createSidebarSlice(...a),
      ...createSearchHighlightSlice(...a),
      ...createPageAnnotationSlice(...a),
    })),
    {
      name: "sky-view-storage",
      version: 1,
      partialize: (state) => ({
        isExpanded: state.isExpanded,
        isDocListCollapsed: state.isDocListCollapsed,
        referenceHighlightsEnabled: state.referenceHighlightsEnabled,
      }),
      migrate: (persistedState): SkyViewPersistedState => {
        if (!persistedState || typeof persistedState !== "object") {
          return {
            isExpanded: true,
            isDocListCollapsed: false,
            referenceHighlightsEnabled: true,
          };
        }

        const referenceHighlightsEnabled =
          "referenceHighlightsEnabled" in persistedState &&
          typeof persistedState.referenceHighlightsEnabled === "boolean"
            ? persistedState.referenceHighlightsEnabled
            : "clickReferencesEnabled" in persistedState &&
                typeof persistedState.clickReferencesEnabled === "boolean"
              ? persistedState.clickReferencesEnabled
              : true;

        return {
          isExpanded:
            "isExpanded" in persistedState &&
            typeof persistedState.isExpanded === "boolean"
              ? persistedState.isExpanded
              : true,
          isDocListCollapsed:
            "isDocListCollapsed" in persistedState &&
            typeof persistedState.isDocListCollapsed === "boolean"
              ? persistedState.isDocListCollapsed
              : false,
          referenceHighlightsEnabled,
        };
      },
    }
  )
);
